import React from "react";
import styles from "./Portal.module.css";
import PortalNav from "./PortalNav/PortalNav";
import Dashboard from "./Dashboard/Dashboard";

function Portal() {
    return (
        <div className={styles["portal-container"]}>
            <PortalNav />
            <Dashboard />
        </div>
    )
}

export default Portal;